"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Tw = (props) => (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 900 600", ...props },
    react_1.default.createElement("g", { fillRule: "evenodd" },
        react_1.default.createElement("path", { fill: "#fe0000", d: "M0 0h900v600H0z" }),
        react_1.default.createElement("path", { fill: "#000095", d: "M0 0h450v300H0z" })),
    react_1.default.createElement("path", { fill: "#fff", d: "m225 37.5-56.25 209.928L322.428 93.75 112.5 150l209.928 56.25L168.75 52.572 225 262.5l56.25-209.928L127.572 206.25 337.5 150 127.572 93.75 281.25 247.428 225 37.5", paintOrder: "markers fill stroke" }),
    react_1.default.createElement("circle", { cx: 225, cy: 150, r: 60, fill: "#fff", stroke: "#000095", strokeWidth: 7.5 })));
exports.default = Tw;
//# sourceMappingURL=Tw.js.map